import walletIcon from '@/assets/images/wallet.svg';
import Button from '@/components/Button';
import user from '@/stores/user';
import { formatHashValue } from '@/utils';
import { useAccountModal, useConnectModal } from '@rainbow-me/rainbowkit';
import makeBlockie from 'ethereum-blockies-base64';
import { observer } from 'mobx-react';

interface Props {
    className?: string;
}

function ConnectWallet({ className = '' }: Props) {
    const { openConnectModal } = useConnectModal();
    const { openAccountModal } = useAccountModal();
    const { connected, address } = user;

    return (
        <>
            <Button
                onClick={
                    !connected || !address ? openConnectModal : openAccountModal
                }
                className={`!h-[40px] gap-[10px] !rounded-[15px] !bg-[linear-gradient(270deg,#9ECBFF_0%,#FDDBFE_50%,#FFFFFF_100%)] !text-[14px] !font-normal ${className}`}
            >
                {!connected || !address ? (
                    <div className="flex items-center gap-[10px]">
                        <img src={walletIcon} alt="wallet" />
                        <span>Connect Wallet</span>
                    </div>
                ) : (
                    <div className="flex items-center gap-[10px]">
                        <img
                            src={makeBlockie(address)}
                            alt="wallet icon"
                            className="h-[24px] w-[24px] rounded-[12px]"
                        />
                        <span>{formatHashValue(address)}</span>
                    </div>
                )}
            </Button>
        </>
    );
}

export default observer(ConnectWallet);
